import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ChildLayout } from './ChildLayout';
import { ChildHomePage } from '../pages/child/ChildHomePage';
import { ChildActivitiesPage } from '../pages/child/ChildActivitiesPage';
import { ChildFocusPage } from '../pages/child/ChildFocusPage';
import { ChildAchievementsPage } from '../pages/child/ChildAchievementsPage';
import { ChildProfilePage } from '../pages/child/ChildProfilePage';

export function ChildPortal() {
  return (
    <Routes>
      <Route path="/" element={<ChildLayout />}>
        <Route index element={<ChildHomePage />} />
        <Route path="activities" element={<ChildActivitiesPage />} />
        <Route path="focus" element={<ChildFocusPage />} />
        <Route path="achievements" element={<ChildAchievementsPage />} />
        <Route path="profile" element={<ChildProfilePage />} />
        <Route path="*" element={<Navigate to="/child" replace />} />
      </Route>
    </Routes>
  );
}